import React from 'react';

import Text from 'components/text';
import type { UserInfo } from 'types';
import Badge from './badge';
import { FONT } from '../constants';

// A&R cell: the assigned A&R as a badge, or a muted dash when unassigned.
const ArCell: React.FC<{ user: UserInfo | null }> = ({ user }) =>
  user?.fullName ? (
    <Badge>{user.fullName}</Badge>
  ) : (
    <Text fontSize={FONT.base} color="#94a3b8">
      —
    </Text>
  );

export default ArCell;
